import store from "store";

export const set = () => {
    if (!process.env.WEBPACK) return;
    store.set("solfaDragHint", "1");
};

export const get = () => {
    if (!process.env.WEBPACK) return false;
    return store.get("solfaDragHint") ? true : false;
};
